import { msg } from '@lingui/core/macro';
import { defineFilters } from '@/shared/filters/define-filters';

import { CATEGORY_NAME, TERM_STATUS } from './product-debit-account.enums';

/**
 * "Filtrar por" do legado (ProdutFilters.tsx:21-32, FilterProvider do contêiner :171-190), na ordem
 * de lá. "Data da ocorrência" fica de fora: no legado ela quebra a tela e nunca chega ao fio (D-01).
 */
export const productDebitAccountFilters = defineFilters([
  {
    key: 'searchString',
    type: 'search',
    label: msg`Todos`,
    placeholder: msg`Filtrar por todos`,
  },
  { key: 'categoryName', type: 'select', label: msg`Categoria do produto`, options: CATEGORY_NAME },
  { key: 'amortizationType', type: 'text', label: msg`Tipo de amortização` },
  { key: 'name', type: 'text', label: msg`Nome do produto` },
  { key: 'termStatus', type: 'select', label: msg`Status de vigência`, options: TERM_STATUS },
]);
